import { Badge, Icon } from 'gu-ui-kit'
import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

export const FormError = ({ error }) => {
  const { t } = useTranslation()

  if (!error?.length) {
    return null
  }

  return (
    <Badge
      className={'margin-top-16'}
      fullWidth
      size={'m'}
      startIcon={
        <Icon
          size={'s'}
          name={'status warning'}
          color={'Accent-Error-Primary'}
        />
      }
      color={'Label-Error-Primary'}
      bgColor={'Background-Error'}
    >
      {t(error)}
    </Badge>
  )
}

FormError.propTypes = {
  error: PropTypes.string,
}
